import "./Philosophy.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurVisionValues from "./sections/OurVisionValues";
import ArchitectsOfChange from "./sections/ArchitectsOfChange";
import Footer from "@/reusable_sections/Footer";
export default function PhilosophyPage() {
  return <div>
      <MainNavigation />
      <OurVisionValues />
      <ArchitectsOfChange />
      <Footer />
    </div>;
}